module.exports = __webpack_public_path__ + "static/media/xls-icon.1319d94c.svg";